import { render, staticRenderFns } from "./EmployeeResidentialAddressHistory.vue?vue&type=template&id=84796e56&scoped=true&"
import script from "./EmployeeResidentialAddressHistory.vue?vue&type=script&lang=js&"
export * from "./EmployeeResidentialAddressHistory.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeResidentialAddressHistory.vue?vue&type=style&index=0&id=84796e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84796e56",
  null
  
)

export default component.exports